// utils/Request.ts
import axios, { AxiosInstance } from "axios";
import { RejectReason } from "./Request.types";
import { configService } from "./ConfigService";

//  internal variable to this module
let service: AxiosInstance;

const createApiService = (): AxiosInstance => {
  const apiEndpoint = configService.getApiEndpoint();
  console.log("Creating/Recreating API service with endpoint:", apiEndpoint);

  const instance = axios.create({
    baseURL: apiEndpoint,
    timeout: 10000,
    maxRedirects: 3,
    headers: {
      common: {
        "Access-Control-Allow-Origin": "*",
      },
    },
  });

  // Setup interceptors on the newly created instance
  setupInterceptors(instance);

  return instance;
};

// Function to reinitialize service with new config
export const reinitializeService = () => {
  service = createApiService();
  console.log("Axios service has been reinitialized.");
};

// Interceptor setup takes an instance as an argument
const setupInterceptors = (axiosInstance: AxiosInstance) => {
  // request interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = ""; //getToken();
      const personId = ""; //getPersonId();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (personId) {
        const method = config.method?.toLowerCase();

        if (method && ["post", "put", "delete"].includes(method)) {
          config.data = {
            ...config.data,
            personId,
          };
        } else if (method === "get") {
          config.params = {
            ...config.params,
            personId,
          };
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // response interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      // Check if the caller wants the full response (via custom config flag)
      if (response.config.headers?.["X-Return-Full-Response"] === "true") {
        return response;
      }
      return response?.data ?? response;
    },
    (error) => {
      return new Promise<RejectReason>((resolve, reject) => {
        console.log("Axios Interceptor Error:", error);
        let msg = "خطای دریافت اطلاعات";

        if (error?.code === "ERR_NETWORK") {
          msg = "خطای نبودن اینترنت یا روشن بودن فیلترشکن ";
          reject({ message: msg });
        } else if (error?.code === "ECONNABORTED") {
          msg = "عدم دریافت پاسخ در زمان مشخص";
          reject({ message: msg });
        }
        //خطای ۵۰۰
        else if (error?.response?.status === 500) {
          msg = "خطای دریافت اطلاعات";

          reject({
            message:
              error?.response?.data && error?.response?.data?.message
                ? error.response.data.message
                : msg,
            data:
              error?.response?.data && error?.response?.data.data
                ? error.response.data.data
                : null,
          });
        } else if (error?.response?.status === 400) {
          //خطای ۴۰۰ bad request
          msg = "خطای ارسال اطلاعات";
          reject({ message: msg });
        } else if (error?.response?.status === 401) {
          //خطای منقضی شدن یا عدم احراز
          msg = "احرازهویت شما منقضی شده است";
          //logoutHandler();
          reject({ message: msg });
        } else {
          //بقیه خطاها
          msg = "خطای ناشناخته";
          reject({ message: msg });
        }
      });
    }
  );
};

// Create and export a "getter" function.
// This ensures that any part of the app calling this will get the most up-to-date instance.
export const getService = (): AxiosInstance => {
  if (!service) {
    // This will be called if a request is made BEFORE initialization is complete.
    // It will use the fallback .env value, which is acceptable.
    // After reinitializeService() runs, subsequent calls will get the correct instance.
    console.warn("Service not yet initialized, creating a fallback instance.");
    service = createApiService();
  }
  return service;
};
